// in HTTP.js
import axios from 'axios';
import config from '@/config';

// create a new axios instance
export default axios.create({
  baseURL: config.API.ENDPOINT,
  withCredentials: true,
});
